
const state = {
  localPhysicalProjectList: JSON.parse(sessionStorage.getItem("localPhysicalProjectList")) || [],
  localLisProjectList:JSON.parse(sessionStorage.getItem("localLisProjectList")) || []
};

const getters = {
  getPhysicalProjectList: state => {
    console.log("getPhysicalProjectList",state.localPhysicalProjectList)
    return  state.localPhysicalProjectList
  },
  getLisProjectList: state => {
    console.log("getLisProjectList",state.localLisProjectList)
    return  state.localLisProjectList
  },
}

const mutations = {
  PhysicalProjectList_SET: (state,data) =>{
    state.localPhysicalProjectList=data;
    sessionStorage.setItem("localPhysicalProjectList", JSON.stringify(data));
  },
  LisProjectList_SET: (state,data) =>{
    state.localLisProjectList=data;
    sessionStorage.setItem("localLisProjectList",JSON.stringify(data));
  },
  EditTabPanel_RESET: state => {
    sessionStorage.removeItem("localPhysicalProjectList")
    sessionStorage.removeItem("localLisProjectList")
    state.localPhysicalProjectList = [];
    state.localLisProjectList = [];
  }
}

const actions = {

}
export default {
  state,
  getters,
  mutations,
  actions
};
